<template>
    <div class="order-history">
        <div class="header">
            <h1>{{ props.title }}</h1>
            <details ref="sortOptionDropdown" class="sort-container mobile-hidden">
                <summary class="sort-button" aria-label="Sort products">
                    Sort: {{ sortOption?.label }}
                </summary>
                <ul class="sort-content">
                    <li v-for="(option, i) in sortOptions" :key="i" class="sort-select paragraph-default">
                        <a @click.prevent="changeSort(option)" href="#" :aria-label="option.label">{{ option.label }}</a>
                    </li>
                </ul>
            </details>
        </div>
        <D2COrderTile
            v-for="(order, index) in props.orders.data"
            :key="index"
            :order="order"
            :id="`order_tile_${index}`"
            style="margin-bottom: 1rem;"
        />
        <pagination
            v-if="(props.orders?.meta?.total || 0) > limit"
            :pagination="{
                totalItems: props.orders?.meta?.total || 0,
                currentPage: props.orders?.meta?.current_page,
                pageSize: limit,
                maxPages: props.orders?.meta?.last_page ?? 1
            }"
            @pageChange="(page) => to({ newParams: { ...preservedParams, page } })"
        />
    </div>
</template>
<script setup lang="ts">
    import { ref, computed, onMounted, inject } from "vue";
    import type { PropType } from "vue";
    import D2COrderTile from "@/components/D2COrderTile.vue";
    import { type OrderResource } from "@interfaces/Order";
    // import { route } from "ziggy-js";
    import { router } from "@inertiajs/vue3";
    import { useRouter } from "@/helpers/composables/useRouter";
    import { onClickOutside } from '@vueuse/core'
    import Pagination from "@/components/Pagination.vue";

    let props = defineProps({
        orders: {
            type: Object as PropType<OrderResource[]>,
            required: true,
            default: () => {
                return [];
            }
        },
        title: {
            type: String,
            default: "Order History"
        },
        view: {
            type: String as PropType<string | null>,
            default: null
        }
    });
    let route = inject('route');
    let sortOption = ref("");
    let sortOptionDropdown = ref(null);

    const limit = ref(4);

    let sortOptions = [
        { label: "Newest First", value: "created_at:desc" },
        { label: "Oldest First", value: "created_at:asc" }
    ];

    const preservedParams = computed(() => {
        return props.view ? { view: props.view } : {};
    });

    onClickOutside(sortOptionDropdown, event => sortOptionDropdownToggle(false));

    const sortOptionDropdownToggle = (val)=>{
        return sortOptionDropdown.value.open = (val === undefined) ? !sortOptionDropdown.value?.open : val;
    }
    const changeSort = (event) => {
        sortOption.value = event;
        sortOptionDropdownToggle(false);
        to({
            newParams: { ...preservedParams.value, orderBy: sortOption.value.value },
            options: {preserveState: true, preserveScroll: true}
        });
    };

    const orderCount = computed(()=>{
        return props.orders?.meta?.total ?? null;
    })

    let { to } = useRouter({
        router,
        route
    });

    onMounted(() => {
        sortOption.value =
            sortOptions.find((opt) => opt.value == route().params["orderBy"]) ??
            sortOptions[0];
    });
</script>
